import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ElectoralLogList } from "@/components/ElectoralLogList";
import { ELogScope } from "@/components/logs/logScope";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { useLogsPermissions } from "@/resources/ElectionEvent/useLogsPermissions";
/**
 * Settings > Logs: the tenant log, laid out like an election event's Logs
 * tab. It holds what happens outside election events: sign-ins, staff
 * accounts and roles, settings and the events' own lifecycle.
 */
export var SettingsLogs = function () {
    var t = useTranslation().t;
    var canReadTenantLogs = useLogsPermissions().canReadTenantLogs;
    if (!canReadTenantLogs) {
        return (_jsx(ResourceListStyles.EmptyBox, { children: _jsx(Typography, { variant: "h4", paragraph: true, children: t("logsScreen.tenant.noPermissions") }) }));
    }
    return (_jsxs(Box, { className: "settings-logs", sx: { minWidth: 0 }, children: [_jsx(Typography, { component: "h2", variant: "h5", sx: { fontWeight: 700 }, children: t("logsScreen.title") }), _jsx(Typography, { variant: "body2", sx: { color: "text.secondary", mb: 2 }, children: t("logsScreen.tenant.subtitle") }), _jsx(ElectoralLogList, { scope: ELogScope.TENANT })] }));
};
